module.exports = __webpack_public_path__ + "img/jka_cycle.1e961dbc.png";